import { rnd } from "../helpers/utils.js"

const SIGNOS_PUNTUACION = new Set([".", ",", ":", ";", "?"]);

const getSelectedText = () => {
  if (!window.getSelection) return ["", -1]

  const sel = window.getSelection(),
    original = sel.toString(),
    index = Math.min(sel.anchorOffset, sel.focusOffset)
  const diff_left = original.length - original.trimStart().length

  return {
    selected_text: original.trim(),
    anchor: index + diff_left,
    alt_anchor: sel.anchorOffset,
  }
}

// index es desde donde inicia la marca siendo 0 la primera posicion de toda la respuesta
const mk_marca = (seleccion, index) => ({
  _fake_id: rnd(16),
  show: true,
  comentario: "",
  correccion: "",
  seleccion,
  comienzo: index,
})

// eslint-disable-next-line
export const r = (t) => `(?<=^|[^a-zA-Z\d\s:])${t}($|[^a-zA-Z\d\s:])`

// toda esta complicacion es culpa de firefox:
// resulta que firefox a veces "capta mal" el valor de la variable
// `window.getSelection().anchorOffset` (en Chrome, este error nunca ocurre).
// Cuando esto ocurre, generalmente le suma +1 a este valor
// Para remediar esto, se propone la siguiente solucion:
// dado un string `padre`, un substring `hijo` y un indice de incio `anchor`,
// se checkea que el substring que queda determinado por padre a partir de la
// posicion `anchor` sea exactamente `hijo`.
// En caso de que no se cumpla, vuelve a intentar, per ahora restandole -1 al
// anchor.
// en caso de que tampoco coincida, se retorna error
const fix_firefox = (padre, hijo, anchor, alt_anchor) => {
  let ok = padre.slice(anchor, anchor + hijo.length) === hijo
  if (ok) {
    return [hijo, anchor]
  }

  // vuelvo a intentar ahora con -1
  let new_anchor = anchor - 1
  ok =
    new_anchor >= 0 &&
    padre.slice(new_anchor, new_anchor + hijo.length) === hijo
  if (ok) {
    return [hijo, new_anchor]
  }

  // un ultimo intento: firefox a veces "detecta mal el doble click"
  // pruebo entonce con alt_anchor
  ok = padre.slice(alt_anchor, alt_anchor + hijo.length) === hijo
  if (ok) {
    return [hijo, alt_anchor]
  }

  // si no, entonces retorno el string vacio a modo de "error"
  return ["", -1]
}

export const Texto = ({
  contenido,
  editable = false,
  handleInsert,
  index_comienzo_texto,
}) => {
  const handleMouseUp = () => {
    if (!editable) return

    const { selected_text, anchor, alt_anchor } = getSelectedText(),
      selection = selected_text,
      index = anchor
    // esto lo desa
    // ,
    // [selection, index] = fix_firefox(
    //   contenido,
    //   selected_text,
    //   anchor,
    //   alt_anchor
    // )

    // index_comienzo_texto es el indice global del comienzo del texto, indice es el comienzo de lo marcado desde este propio elemento.

    // este posible ajuste es porque cuando se intenta marcar un espacio en blanco
    // a veces marca el siguiente
    var a_index = index
    const contenido_es_blanc_pero_quedo_indice_de_adelante =
      selection.length === 0 &&
      (index > 0 ? contenido[index - 1] === " " : false) &&
      contenido[index] !== " "

    if (contenido_es_blanc_pero_quedo_indice_de_adelante) {
      a_index = a_index - 1
    }

    // Se hace para evitar que se inserten anotaciones dentro de palabras, p.e.: ped*anotacion*ro.
    const contenido_es_espacio_en_blanco =
        selection.length === 0 && contenido[a_index] === " ",
      contenido_es_signo_puntuacion =
        selection.length === 1 && SIGNOS_PUNTUACION.has(contenido[a_index]),
      antes_hay_espacio_o_inicio =
        a_index > 0
          ? contenido[a_index - 1] === " " ||
            SIGNOS_PUNTUACION.has(contenido[a_index - 1]) ||
            contenido[a_index - 1] === "\n"
          : true,
      hay_salto_de_linea_o_puntuacion =
        (contenido[a_index + selection.length] === "\n" ||
          SIGNOS_PUNTUACION.has(contenido[a_index + selection.length])) &&
        contenido[a_index + selection.length - 1] !== " ",
      despues_hay_espacio_o_final =
        a_index + selection.length < contenido.length
          ? (contenido[a_index + selection.length] === " " ||
            hay_salto_de_linea_o_puntuacion)
          : true,
      contenido_tiene_largo_positivo_y_palabras_enteras =
        contenido.length > 0 &&
        (antes_hay_espacio_o_inicio || a_index === 0) &&
        (despues_hay_espacio_o_final ||
          a_index + selection.length === contenido.length)
    var ok =
      contenido_es_espacio_en_blanco ||
      contenido_tiene_largo_positivo_y_palabras_enteras ||
      contenido_es_signo_puntuacion

    console.log("selection", selection, "selection.length", selection.length)
    console.log(
      "antes_hay_espacio_o_inicio",
      antes_hay_espacio_o_inicio,
      "despues_hay_espacio_o_final",
      despues_hay_espacio_o_final,
      "contenido_tiene_largo_positivo_y_palabras_enteras",
      contenido_tiene_largo_positivo_y_palabras_enteras,
      "contenido_es_signo_puntuacion",
      contenido_es_signo_puntuacion,
      "contenido[a_index + selection.length]",
      contenido[a_index + selection.length],"---"
    )

    if (!ok) return

    const padding_f_interno = selection.length === 0 ? 1 : selection.length,
      f_interno = a_index + padding_f_interno,
      clean = contenido.slice(0, a_index),
      seleccion = contenido.slice(a_index, f_interno),
      resto = contenido.slice(f_interno)

    //TODO: aca en mk_marca deberia pasarle el indice de donde inicia para asi guardarlo en la base
    // handleInsert(
    //   [clean, mk_marca(seleccion, index + largo_hasta_aqui), resto].filter(
    //     (x) => x !== ""
    //   )
    // )
    handleInsert(
      [
        clean,
        mk_marca(seleccion, a_index + index_comienzo_texto),
        resto,
      ].filter((x) => x !== "")
    )
  }

  return (
    <>
      <div
        className="d-inline selectable-texty texto-con-espacios"
        onMouseUp={handleMouseUp}>
        {contenido}
      </div>
    </>
  )
}
